
import React, { useState } from 'react';
import { AlertTriangle, Bell, CheckCircle, Filter, X, User, Clock } from 'lucide-react';

const CriticalAlerts = ({ alerts }) => {
  const [filteredSeverity, setFilteredSeverity] = useState('all');
  const [filteredType, setFilteredType] = useState('all');
  
  // Filter alerts based on selected severity and type
  const filteredAlerts = alerts.filter(alert => {
    return (filteredSeverity === 'all' || alert.severity === filteredSeverity) && 
           (filteredType === 'all' || alert.type === filteredType);
  });
  
  // Get unique alert types for filter dropdown
  const alertTypes = ['all', ...new Set(alerts.map(alert => alert.type))];
  
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900 flex items-center">
          <Bell size={18} className="mr-2 text-purple-700" />
          Critical Alerts
        </h3>
        <div className="flex items-center">
          <div className="mr-2">
            <select 
              className="text-xs border border-gray-200 rounded-md px-2 py-1"
              value={filteredSeverity}
              onChange={(e) => setFilteredSeverity(e.target.value)}
            >
              <option value="all">All Severity</option>
              <option value="high">High</option>
              <option value="medium">Medium</option>
              <option value="low">Low</option>
            </select>
          </div>
          <div>
            <select 
              className="text-xs border border-gray-200 rounded-md px-2 py-1"
              value={filteredType}
              onChange={(e) => setFilteredType(e.target.value)}
            >
              {alertTypes.map(type => (
                <option key={type} value={type}>
                  {type === 'all' ? 'All Types' : type.charAt(0).toUpperCase() + type.slice(1)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      
      <div className="space-y-4 max-h-80 overflow-y-auto">
        {filteredAlerts.length > 0 ? (
          filteredAlerts.map((alert) => (
            <div key={alert.id} className={`p-3 rounded-md ${
              alert.severity === 'high' ? 'bg-red-50' : 
              alert.severity === 'medium' ? 'bg-yellow-50' : 'bg-blue-50'
            }`}>
              <div className="flex items-start">
                <div className={`p-1 rounded-md mr-3 ${
                  alert.severity === 'high' ? 'bg-red-100' : 
                  alert.severity === 'medium' ? 'bg-yellow-100' : 'bg-blue-100'
                }`}>
                  <AlertTriangle size={16} className={
                    alert.severity === 'high' ? 'text-red-500' : 
                    alert.severity === 'medium' ? 'text-yellow-500' : 'text-blue-500'
                  } />
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-start">
                    <p className="text-sm font-medium text-gray-800">{alert.message}</p>
                    <span className={`ml-2 text-xs px-2 py-0.5 rounded-full ${
                      alert.type === 'competitive' ? 'bg-purple-100 text-purple-800' : 
                      alert.type === 'performance' ? 'bg-red-100 text-red-800' :
                      alert.type === 'operational' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-green-100 text-green-800'
                    }`}>
                      {alert.type}
                    </span>
                  </div>
                  <div className="flex mt-2 justify-between">
                    <p className="text-xs text-gray-500 flex items-center">
                      <Clock size={12} className="mr-1" />
                      {alert.timestamp}
                    </p>
                    <div className="flex space-x-2">
                      <button className="text-xs text-purple-600 flex items-center">
                        <User size={12} className="mr-1" />
                        Assign
                      </button>
                      <button className="text-xs text-green-600 flex items-center">
                        <CheckCircle size={12} className="mr-1" />
                        Resolve
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-4 text-gray-500">
            No alerts match your filter criteria
          </div>
        )}
      </div>
      
      <div className="mt-4 flex justify-between items-center">
        <span className="text-xs text-gray-500">Last updated 5 minutes ago</span>
        <button className="text-sm text-purple-700 hover:text-purple-900">View All Alerts</button>
      </div>
    </div>
  );
};

export default CriticalAlerts;
